var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AbsBox',{staticClass:"hoverlay"},[_c('button',{staticStyle:{"all":"unset","width":"100%","height":"100%"},on:{"click":_vm.onclick}})])}
var staticRenderFns = []

export { render, staticRenderFns }